import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	Container,
	Button,
	Row,
	Col,
	Table,
	UncontrolledButtonDropdown,
	DropdownItem,
} from 'reactstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import {
	CloudDownloadOutlined,
	FirstPageOutlined,
	LastPageOutlined,
	ChevronRightOutlined,
	ChevronLeftOutlined,
	Settings,
	FileCopyOutlined,
	FindInPageOutlined,
	LinkOutlined,
	CancelOutlined,
} from '@mui/icons-material';
import Pagination from 'react-js-pagination';

import * as ActionsLinks from '~/store/modules/client/maquinaVirtual/actions';
import { LoaderLista, LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';
import history from '~/services/history';
import { symbolPriceFormatter } from '~/helpers/price';
import { TransactionsContext } from '~/context/TransactionsContext';

import ReactGA from 'react-ga4';
import api from '../../link-pagamento/helpers/api';
import {
	ItemConfig,
	FilterAndDown,
	TextClick,
	TrStyled,
	DropdownToggleStyled,
	DropdownMenuStyled,
} from './styles';

function CanceledItem({ item }) {
	const { user } = useSelector((state) => state.auth);
	function refreshPage() {
		window.location.reload(false);
	}

	return (
		<DropdownItem
			onClick={() =>
				Swal.fire({
					title: 'Cancelamento Link Pagamento',
					text: 'ATENÇÃO: Esta ação não pode ser desfeita',
					showCancelButton: true,
					confirmButtonText: 'Sim',
					cancelButtonText: 'Não',
					width: '800px',
					html: `
						<div>
							<h5>Dados do Link</h5>
						</div>
						<div>
							<b>Título:</b>
							${item.link_title}
						</div>
						<div>
							<b>Valor total:</b>
							${symbolPriceFormatter(item.amount, 'detalheLink')}
						</div>
						<div>
							<b>Número de Parcelas:</b>
							${item.installments}x
						</div>
						<div>
							<b>Valor por parcela:</b>
							${symbolPriceFormatter(item.amount_per_installment, 'detalheLink')}
						</div>`,
					showLoaderOnConfirm: true,
					preConfirm: async () => {
						try {
							await api.token(user.dados.documento);
							await api.link.cancelLink(item);
							toast.success('Link Cancelado com Sucesso');
							refreshPage();
						} catch (error) {
							toast.error('Error ');
							// eslint-disable-next-line no-console
							console.log(error);
						}
					},
					allowOutsideClick: () => Swal.isLoading(),
				})
			}>
			<CancelOutlined />
			<span className="ml-2">Cancelar Link</span>
		</DropdownItem>
	);
}

export default function MaquinaVirtual() {
	const maquinaVirtual = useSelector((state) => state.clientMaquinaVirtual);
	const { user } = useSelector((state) => state.auth);

	const {
		authToken,
		getExportLucreePorClick,
		loaderDownload,
		setLoaderDownload,
	} = useContext(TransactionsContext);
	const dispatch = useDispatch();

	const [pagina, setPagina] = useState(1);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		dispatch(ActionsLinks.requestLinks(`${pagina}/10`, user));
	}, [dispatch, pagina]);

	function handlerPagination(page) {
		setPagina(page);
		dispatch(ActionsLinks.requestLinks(`${pagina}/10`, user));
	}

	function handlerDetalhe(link) {
		dispatch(ActionsLinks.requestDetalheLink(link));
		history.push(`/client/detalhes-link`);
	}

	function handlerCopy(item) {
		navigator.clipboard.writeText(item.link);
		toast.success('Link copiado');
	}

	function handlerVisualizarCheckout(item) {
		window.open(item.link, '_blank');
	}

	function handleClickDownloadLinkGeradoGA4() {
		ReactGA.event({
			category: "download_link_gerado_click",
			action: "Download Link Gerado - Lucree por Click",
			label: "Baixando Link Gerado Lucree por Click",
		});
	}

	function handleClickLucreePorClickGA4() {
		ReactGA.event({
			category: "lucree_por_click",
			action: "Acesso ao Lucree por Click",
			label: "Acessando Lucree por Click",
		});
	}

	useEffect(() => {
		handleClickLucreePorClickGA4();
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Lucree por click',
						link: '/client/maquina-virtual',
					},
				]}
			/>
			<Row className="mt-5 mb-3 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Lucree por click</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Button
						color="primary my-0"
						onClick={() => history.push('/client/novo-link')}>
						Novo link
					</Button>
				</Col>
			</Row>
			<Row className="mb-3">
				<Col>
					<Text size="big">Meus links gerados</Text>
				</Col>
			</Row>
			<Row className="mt-5">
				<Col>
					<LoaderLista
						loading={maquinaVirtual.loading}
						lista={maquinaVirtual.lista}
						error={maquinaVirtual.error}>
						<FilterAndDown>
							{/* {user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
								<> */}
							{!loaderDownload ? (
								<TextClick
									tabIndex="0"
									role="button"
									onClick={() => {
										setLoaderDownload(true);
										authToken().then(() => {
											getExportLucreePorClick(
												user.dados.gateway_token,
												pagina
											);
											handleClickDownloadLinkGeradoGA4();
										});
									}}>
									<CloudDownloadOutlined className="mr-1" />
									Fazer Download
								</TextClick>
							) : (
								<LoaderMini />
							)}
							{/* </>
							} */}
						</FilterAndDown>
						<div className="table-overflow-x">
							<Table responsive>
								<thead>
									<TrStyled>
										<th>Data</th>
										<th>Título</th>
										<th>Valor</th>
										<th>Parcelas</th>
										<th>Status</th>
										<th
											width="80"
											style={{ textAlign: 'center' }}>
											Detalhes
										</th>
									</TrStyled>
								</thead>
								<tbody>
									{maquinaVirtual.lista.map((item) => (
										<TrStyled key={item.link}>
											<td>
												{moment(item.created_at).subtract(3, 'hours').format(
													'DD/MM/YYYY'
												)}
											</td>

											<td>{item.link_title}</td>

											<td>
												{symbolPriceFormatter(
													item.amount,
													'detalheLink'
												)}
											</td>
											<td>{item.installments}</td>
											<td>
												{item.canceled ? (
													<Text
														weight="bold"
														color="red">
														Cancelado
													</Text>
												) : (
													<Text
														weight="bold"
														color={
															item.paid
																? 'green'
																: 'orange'
														}>
														{item.paid
															? 'Pago'
															: 'Pendente'}
													</Text>
												)}
											</td>
											<td>
												<UncontrolledButtonDropdown>
													<DropdownToggleStyled>
														<Settings />
													</DropdownToggleStyled>
													<DropdownMenuStyled right>
														{item.paid ? (
															<>
																<ItemConfig>
																	<FileCopyOutlined />
																	<span className="ml-2">
																		Copiar
																		Link
																	</span>
																</ItemConfig>
																<ItemConfig>
																	<FindInPageOutlined />
																	<span className="ml-2">
																		Visualizar
																		Checkout
																	</span>
																</ItemConfig>
															</>
														) : (
															<>
																<DropdownItem
																	onClick={() =>
																		handlerCopy(
																			item
																		)
																	}>
																	<FileCopyOutlined />
																	<span className="ml-2">
																		Copiar
																		Link
																	</span>
																</DropdownItem>
																<DropdownItem
																	onClick={() =>
																		handlerVisualizarCheckout(
																			item
																		)
																	}>
																	<FindInPageOutlined />
																	<span className="ml-2">
																		Visualizar
																		Checkout
																	</span>
																</DropdownItem>
															</>
														)}
														{!item.canceled && (
															<CanceledItem
																item={item}
															/>
														)}
														<DropdownItem
															onClick={() =>
																handlerDetalhe(
																	item.cryptogram
																)
															}>
															<LinkOutlined />
															<span className="ml-2">
																Detalhes do Link
															</span>
														</DropdownItem>
													</DropdownMenuStyled>
												</UncontrolledButtonDropdown>
											</td>
										</TrStyled>
									))}
								</tbody>
							</Table>
						</div>
					</LoaderLista>
					<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
						<Pagination
							activePage={pagina}
							totalItemsCount={
								maquinaVirtual.dados.total
									? maquinaVirtual.dados.total
									: 0
							}
							onChange={(page) => handlerPagination(page)}
							prevPageText={<ChevronLeftOutlined />}
							nextPageText={<ChevronRightOutlined />}
							firstPageText={<FirstPageOutlined />}
							lastPageText={<LastPageOutlined />}
						/>
					</div>
				</Col>
			</Row>
		</Container>
	);
}
